/**
 * Created by alex.y on 8/8/2017.
 */
export enum TaxType {
    CustomDuty = 1,
    CustomGST = 2,
    CustomPST = 3,
    AAFee = 4,
    AAFeeGST = 5,
    AAFeePST = 6,

    CustomMPF = 7,
    CustomHMF = 8,
    ClassificationFee = 9,
    Bond = 10,
    BondUnderFee = 11,
    CustomISF = 12,
    DutyDistRate = 13,
    NAFTA = 14,
    ABIFee = 15,
    FDA = 16,
    ImportRegisterFee = 17,
    PAPSFee = 18,
    AdminFee = 19,
    Manual = 20,
    ITN = 21,
    RIV = 22,
    FormOne = 23,
    AC = 24,
    UsedEquipment = 25,
    GreenLevy = 26,
    EManifest = 27,

    SoilExamFee = 28,
    AgentPortFee = 29

}



// WEBPACK FOOTER //
// ./app/objects/orders/taxType.ts